import React, { useContext } from "react";

import { DimensionsContext, DimensionsProvider } from "./Dimensions";
import useWindowSizeEffect from "./useWindowSizeEffect";

type Props = {
  children: React.ReactNode;
};

export default function WindowDimensionsProvider({ children }: Props) {
  const { height, width } = useWindowSizeEffect();
  return (
    <DimensionsProvider height={height} width={width}>
      {children}
    </DimensionsProvider>
  );
}

export const useWindowSize = () => useContext(DimensionsContext);
